<template>
  <div class="gonggaoContent">
    <div class="head">
      <div class="title">{{ data.title }}</div>
      <div class="dibu">
        <div class="time">时间: {{ data.starttime }}</div>
        <div
          class="from"
          v-if="data.hasOwnProperty('source') && !data.source == ''"
        >
          来源：{{ data.source }}
        </div>
      </div>
    </div>
    <div class="content" v-html="content"></div>
  </div>
</template>

<script>
import qs from "qs";
import { Dialog } from "vant";
import { Toast } from "vant";

export default {
  mounted() {
    this.getGonggaoListDetail();

    document.querySelector("html").removeAttribute("style");
    this.$apis.CmsInterface.addIntegral(this.$axios, {
      type: 1,
      creditDesc: "阅读-首页公告",
      noticeId: this.$route.query.NewsId,
    });
  },
  data() {
    return {
      content: "",
      contentTitle: "",
      starttime: "",
      from: "",
      data: Object,
    };
  },
  methods: {
    getGonggaoListDetail() {
      this.$toast.loading({
        message: "数据加载中...",
        forbidClick: true,
      });
      let params = qs.stringify({
        metacode: "HOMENOTICE",
        id: this.$route.query.NewsId,
      });
      this.$axios
        .post("appapi/cmsInterface/getCmsInfo", params)
        .then((res) => {
          if (res.data.result !== 1) {
            Toast.clear();
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            Toast.clear();
            console.log(res);
            if (res.data.data.url && res.data.data.url != "") {
              window.location.href = res.data.data.url;
              return;
            } else {
              this.content = res.data.data.content;
              res.data.data.starttime = res.data.data.starttime.substring(
                0,
                10
              );
              this.data = res.data.data;
            }
          }
        })
        .catch((err) => {
          Toast.clear();
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 0 15px !important;
  margin-bottom: 100px;
}
.content ::v-deep img {
  width: 330px;
  height: auto;
}
.gonggaoContent {
  background-color: #ffff;
}
.head {
  padding: 13px 16px 0 16px;
  .title {
    color: #19212a;
    font-size: 22px;
    line-height: 32px;
    font-weight: 500;
  }
  .dibu {
    display: flex;
    align-items: center;
    margin-top: 12px;
    padding-bottom: 11px;

    .time {
      color: #878787;
      font-size: 13px;
    }
    .from {
      color: #878787;
      font-size: 13px;
      margin-left: 1rem;
    }
  }
}
</style>